import { useResource } from '@landsbankinn/l16n';
import { Box, Row, UnstyledLink } from '@landsbankinn/ui-kit';
import { res } from './Footer.res';

export function Footer() {
  const { r } = useResource();

  return (
    <Box as="footer" role="contentinfo" paddingTop="24" color="blue font">
      <Row
        wrap="no wrap"
        mainAxisAlignment="center"
        crossAxisAlignment="center"
      >
        <Box paddingVertical="28" paddingHorizontal="33">
          <UnstyledLink
            href={r(res.privacyLink)}
            fontVariant="body small"
            target="_blank"
            rel="noreferrer"
          >
            {r(res.privacy)}
          </UnstyledLink>
        </Box>
        <Box paddingVertical="28" paddingHorizontal="33">
          <UnstyledLink
            href={r(res.legalNoticeLink)}
            fontVariant="body small"
            target="_blank"
            rel="noreferrer"
          >
            {r(res.legalNotice)}
          </UnstyledLink>
        </Box>
        <Box paddingVertical="28" paddingHorizontal="33">
          <UnstyledLink
            href="https://www.landsbankinn.is"
            fontVariant="body small"
            target="_blank"
            rel="noreferrer"
          >
            landsbankinn.is
          </UnstyledLink>
        </Box>
      </Row>
    </Box>
  );
}
